import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceEditLayer from "../components/InvoiceEditLayer";
import SaleReturnEdit from "../components/SaleReturnEdit";




const SaleReturnEditPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Invoice - Edit" /> */}

        {/* InvoiceEditLayer */}
        <SaleReturnEdit />

      </MasterLayout>

    </>
  );
};

export default SaleReturnEditPage;
